<template>
    <div class="cooperate-form">
        <div class="content-header">
            <el-table :data="likeMe" stripe border center :size="GCONFIG.styleTableSize" style="margin: 18px 0">
                <el-table-column type="index" label="序号" width="50"></el-table-column>
                <el-table-column label="who@我" prop="userNick" width="90"></el-table-column>
<!--                <el-table-column label="问题" prop="questionName"></el-table-column>-->
                <el-table-column label="内容">
                    <template slot-scope="scope">
                        <p v-html="scope.row.content" style="text-align: left"></p>
                    </template>
                </el-table-column>
<!--                <el-table-column label="提问时间" prop="createTime" width="70"></el-table-column>-->
                <el-table-column label="回复内容">
                    <template slot-scope="scope">
                        <p v-html="scope.row.answerContent" style="text-align: left"></p>
                    </template>
                </el-table-column>
                <el-table-column label="是否回复" prop="relationUserName" width="90">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.isAnswer==1" type="success">已回复</el-tag>
                        <el-tag v-else type="danger">未回复</el-tag>
                    </template>
                </el-table-column>

                <el-table-column label="操作" fixed="right">
                    <template slot-scope="scope">
                        <el-button :disabled="scope.row.isAnswer==1" type="primary" size="mini" @click="showCallbackDialog(scope.row.relationId)">回复</el-button>
                    </template>
                </el-table-column>

            </el-table>
            <div class="pagination-wrap">
                <el-pagination
                        background
                        :hide-on-single-page="formInline.pageSize>=recordsTotal"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="formInline.currentPage"
                        :page-sizes="GCONFIG.pageSizes"
                        :page-size="formInline.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="recordsTotal">
                </el-pagination>
            </div>
            <el-dialog
                    title="回复(不少于5个字)"
                    :visible.sync="showDialog"
                    width="50%"
                    center
                    @close="closeCallBackDialog">
                <el-input
                        type="textarea"
                        :rows="2"
                        autosize
                        placeholder="请输入内容(不少于5个字)"
                        v-model="callBackCommitContent" maxlength="5000" minlength="5" show-word-limit>
                </el-input>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" :disabled="callBackCommitContent.length<5" @click="callBackComment(paperId,periodId)">确 定</el-button>
                </span>
            </el-dialog>
        </div>
    </div>
</template>

<script>

    //定义组件
    export default {
        data() {
            return {
                formInline: {
                    currentPage: 1,
                    pageSize: 50,
                    classId:1,
                    ctype:18,
                    isself:0
                },
                likeMe:[],
                recordsTotal:0,
                showDialog:false,
                callBackCommitContent:'',
                relationId:''
            }
        },
        computed:{

        },
        props:['sectionClassId'],
        //挂载时候执行
        mounted() {
            this.formInline.classId = this.sectionClassId
            this.getCooperativeCallMe()
        },
        methods: {
            getCooperativeCallMe() {
                this.$store.dispatch('initCooperativeCallMe',this.formInline).then(res=>{
                    this.likeMe = res.list
                    this.recordsTotal = res.total
                })
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getCooperativeCallMe()
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getCooperativeCallMe()
            },
            callBackComment(){
                this.$store.dispatch('cooperativeCallBack',{relationId:this.relationId,content:this.callBackCommitContent}).then(res=>{
                    this.showDialog = false
                    this.relationId = ''
                    this.getCooperativeCallMe()
                })
            },
            closeCallBackDialog(){
                this.showDialog = false
                this.relationId = ''
            },
            showCallbackDialog(id){
                this.showDialog = true
                this.relationId = id

            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/cooperative/cooperativeCall.vue